export default {
  offers: {
    offersHeading: '標準オファー',
    discountAmount: '割引額',
    discountPercentage: '割引率',
    noOffers:
      'オファーはまだ追加されていません。「新しいオファーを追加」をクリックして最初のオファーを作成してください。',
    saveSelectedOffers: '選択したオファーを保存',
    loading: '読み込み中...',
    addNewOffer: '新しいオファーを追加',
    editOffer: 'オファーを編集',
    edit: '編集',
    remove: '削除',
    save: '保存',
    saving: '保存中...',
    saveOffers: '支払う',
    create: '作成',
    cancel: 'キャンセル',
    description: '説明',
    enterOfferName: 'オファー名を入力',
    enterDescription: 'オファーの簡単な説明を入力',
    inclusions: '含まれるもの（1行に1つ）',
    inclusionsPlaceholder: 'ブース備品\nWiFi\nバッジ2枚\n電気',
    inclusionsHelper: '含まれるものを1行ずつ入力してください',
    successCreate: 'オファーを作成しました',
    successUpdate: 'オファーを更新しました',
    successDelete: 'オファーを削除しました',
    errors: {
      save: 'オファーの保存に失敗しました。もう一度お試しください。',
      nameRequired: 'オファー名を入力してください',
      priceInvalid: '有効な価格を入力してください',
    },
  },
};
